import React from 'react';
import { Container, FilterIcon, FilterName } from './styles';
import { FilterCardProps } from './types';

export const FilterCard: React.FC<FilterCardProps> = (props) => {
  const { icon, label, onClick } = props;
  return (
    <Container onClick={onClick}>
      <FilterIcon>{icon}</FilterIcon>
      <FilterName>{label}</FilterName>
    </Container>
  );
};
